export const RUNBOOK_RESOURCE_TYPES = {
  ALERT_POLICY: 'alert_policy',
  ALERT_POLICY_TEMPLATE: 'alert_policy_template'
} as const;

export type RunbookResourceType = (typeof RUNBOOK_RESOURCE_TYPES)[keyof typeof RUNBOOK_RESOURCE_TYPES];
